'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var Model = require('./../models/vote-option');

module.exports = Backbone.Collection.extend({
    model: Model,

    initialize: function(attrs, options, enable_eliminated) {
        // if show eliminated enabled sort based on eliminated and first name, otherwise firstname
        // need to create what happens if you do not want to display eliminated contestants
        this.options = options || {};

        if (!this.options.randomize) {
            this.comparator = function(model) {
                if (enable_eliminated) return [model.get('eliminated'), model.get(this.options.sorting_key)];
                else return model.get(this.options.sorting_key);
            };
        }
    },

    set: function(models, options) {
        if (this.options.randomize) {
            models = _.shuffle(models);
        }
        Backbone.Collection.prototype.set.call(this, models, options);
    },

    setSelected: function(id) {
        console.log('selected model id', id);

        this.each(function(model) {
            model.set({ selected: false }, { silent: true });
        });

        this.get(id).set({ selected: true });
        this.selectedElement = this.get(id);
    },

    getSelected: function() {
        return this.selectedElement || this.at(0);
    },

    next: function(option) {
        var model = this.at(this.indexOf(option) + 1);

        if (_.isUndefined(model)) {
            model = this.last();
        }

        return model;
    },

    prev: function(option) {
        var model = this.at(this.indexOf(option) - 1);

        if (_.isUndefined(model)) {
            model = this.first();
        }

        return model;
    },

    search: function(value) {
        var lastIndex = value.lastIndexOf(' ');
        var firstName = value.substr(0, lastIndex);
        var lastName = value.substr(lastIndex + 1);

        console.log('first name:', firstName, 'lastName:', lastName);
    },
    /**
     * clearVoteCount
     *
     * Set all models to zero
     */
    clearVoteCount: function(params) {
        params = params || {};
        _.each(this.models, function(model) {
            model.set(
                {
                    voteCount: 0,
                    selected: false
                },
                params
            );
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/collections/vote-option.js
// module id = 279
// module chunks = 0